let env = process.env.NODE_ENV || 'development';
let configEnv = process.env.CONFIG_ENV || 'local';

let envConfig = {
    // local 先用st的环境变量
    local: {
        name: 'local',
        SSO_CLIENTID: '056ee86189',
        SSO_HOST: 'https://ssosv.sankuai.com',
        SSO_USER: 'https://shuju.sankuai.com',
        SERVER_HOST: 'https://brain.inf.st.sankuai.com',
        publicPath: '/',
        // urlPrefix: 'http://brain.inf.st.sankuai.com',
        // urlPrefix: 'https://brain.meituan.com/brain-api',
        // urlPrefix: 'https://brain.sankuai.com',
        urlPrefix: 'https://brain.meituan.com',
        isPublic: true,
    },
    test: {
        name: 'test',
        SSO_CLIENTID: '056ee86189',
        SSO_HOST: 'http://ssosv.it.test.sankuai.com',
        SSO_USER: 'https://shuju.inf.test.sankuai.com',
        SERVER_HOST: 'http://brain.inf.test.sankuai.com',
        urlPrefix: 'http://brain.inf.test.sankuai.com',
        publicPath: '//static.fetc.test.sankuai.com/nlp-kg-static/',
    },
    staging: {
        name: 'staging',
        SSO_CLIENTID: '056ee86189',
        SSO_HOST: 'https://ssosv.sankuai.com',
        SSO_USER: 'https://shuju.sankuai.com',
        SERVER_HOST: 'https://brain.inf.st.sankuai.com',
        urlPrefix: 'http://brain.inf.st.sankuai.com',
        publicPath: '//static.fetc.st.sankuai.com/nlp-kg-static/',
    },
    prod: {
        name: 'prod',
        SSO_CLIENTID: '056ee86189',
        SSO_HOST: 'https://ssosv.sankuai.com',
        SSO_USER:'https://shuju.sankuai.com',
        SERVER_HOST: 'https://brain.sankuai.com',
        urlPrefix: 'https://brain.sankuai.com',
        publicPath: '//s0.meituan.net/mxx/nlp-kg-static/',
    },
    'prod-public': {
        name: 'prod-public',
        SSO_CLIENTID: '056ee86189',
        SSO_HOST: 'https://ssosv.sankuai.com',
        SSO_USER: 'https://shuju.sankuai.com',
        SERVER_HOST: 'https://brain.meituan.com',
        urlPrefix: 'https://brain.meituan.com',
        publicPath: '//s0.meituan.net/mxx/nlp-kg-static-public/',
    }
};

let Config = envConfig[configEnv];
Config.env = env;
// 本地环境强制 publicPath 为 /
if (Config.env === 'development') {
    Config.publicPath = '/';
}
if (Config.isPublic === undefined) {
    Config.isPublic = Config.name === 'prod-public';
}

console.log('env-config:', JSON.stringify(Config));
module.exports = Config;


